import { LocationWiseSalesAnalyticsItem } from '@/services/salesPerformance/salesPerformance.types';

const toStartOfDay = (date: Date) =>
  // normalize to UTC midnight to avoid local timezone shifts when mapping dates
  new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));

export const getWeekRange = (referenceDate = new Date(), offset = 0) => {
  const today = toStartOfDay(referenceDate);

  // Calculate the target date based on offset
  const targetDate = new Date(today);
  targetDate.setUTCDate(targetDate.getUTCDate() - offset * 7);

  // Get the day of the week (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
  const dayOfWeek = targetDate.getUTCDay();

  // Calculate Monday: if dayOfWeek is 0 (Sunday), go back 6 days; otherwise go back (dayOfWeek - 1) days
  const daysToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
  const start = new Date(targetDate);
  start.setUTCDate(start.getUTCDate() - daysToMonday);

  // Calculate Sunday: 6 days after Monday
  const end = new Date(start);
  end.setUTCDate(end.getUTCDate() + 6);

  return { start, end };
};

export const formatRangeDate = (date: Date) => {
  // format using UTC parts to match normalized UTC day boundaries
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');

  return `${year}.${month}.${day}`;
};

export const isDateInRange = (date: Date, start: Date, end: Date) => {
  const normalizedDate = toStartOfDay(date).getTime();
  const normalizedStart = toStartOfDay(start).getTime();
  const normalizedEnd = toStartOfDay(end).getTime();

  return normalizedDate >= normalizedStart && normalizedDate <= normalizedEnd;
};

export const filterWeekData = (rawData: LocationWiseSalesAnalyticsItem[], start: Date, end: Date) =>
  rawData
    .filter((item) => {
      const itemDate = Number(item.date);
      if (Number.isNaN(itemDate)) {
        return false;
      }

      return isDateInRange(new Date(itemDate), start, end);
    })
    .sort((a, b) => Number(a.date) - Number(b.date));
